import React from "react";
import { FlowDialog, ImageElement } from "./FlowDialog";
import StressedLadyImage from "../../assets/StressedPicture.png";
import { Box } from "@mui/material";
import {
  ChangeCountryForm,
  RadioOption,
  LanguageOption,
} from "./ChangeCountryForm";

export interface Props {
  open: boolean;
  handleClose: () => void;
  onComplete: (countryId: number, languageCode?: string) => Promise<boolean>;
  newCountryId?: number;
  userCountryId?: number;
}

export const ChangeCountryDialog = ({
  open,
  handleClose,
  onComplete,
  newCountryId,
  userCountryId,
}: Props): JSX.Element => {
  const stressedLadyIcon: ImageElement = {
    src: StressedLadyImage,
    alt: "Stressed Elderly Lady",
  };

  const canadaLanguageOptions: LanguageOption[] = [
    {
      name: "English",
      code: "en",
    },
    { name: "French", code: "fr" },
  ];

  const usLanguageOptions: LanguageOption[] = [
    {
      name: "English",
      code: "en",
    },
  ];

  let options: RadioOption[] = [];

  if (userCountryId && newCountryId && userCountryId != newCountryId) {
    options = [
      {
        value: newCountryId.toString(),
        label: `Change my Atticus Account to ${
          newCountryId == 1 ? "the United States" : "Canada"
        } and keep this inputted address.`,
        languageOptions:
          newCountryId == 1 ? usLanguageOptions : canadaLanguageOptions,
      },
      {
        value: userCountryId.toString(),
        label: `Choose a ${
          userCountryId == 1 ? "United States" : "Canadian"
        } address for the estate.`,
      },
    ];
  }

  return (
    <FlowDialog
      open={open}
      handleClose={handleClose}
      image={stressedLadyIcon}
      title={`It looks like this estate is in ${
        newCountryId == 1 ? "the United States" : "Canada"
      } but you signed up for Atticus in ${
        userCountryId == 1 ? "the United States" : "Canada"
      }`}
      subtitle={`Let's switch your account over to ${
        newCountryId == 1 ? "the United States" : "Canada"
      }.`}
      body={
        <Box>
          <ChangeCountryForm
            errorText="Oops! Fully complete this question to continue."
            options={options}
            onComplete={onComplete}
            currentUserCountryId={userCountryId ? userCountryId : 1}
          />
        </Box>
      }
    />
  );
};
